import { Button, Checkbox, Col, Input, message, Popconfirm, Row, Select } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";

export default function UpCamProfilesFunction() {
  const [messageApi, contextHolder] = message.useMessage();

  const [sheetURL_p, setSheetURL_p] = useState('');
  const [sheetName_p, setSheetName_p] = useState('');

  const [checkExistedCampaign, setCheckExistedCampaign] = useState(false);
  const [includesKeyword, setIncludesKeyword] = useState(true);
  const [includesAds, setIncludesAds] = useState(true);
  const [sheetURL_c, setSheetURL_c] = useState('');
  const [sheetName_c, setSheetName_c] = useState('');
  const [pages, setPages] = useState([]);

  const [tabsNum, setTabsNum] = useState('10');

  const upCam = async () => {
    if(!sheetURL_p) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`>>> Up  Profiles...`);
    let body = {
      sheetProfiles: {
        sheetId: sheetURL_p.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_p,
      },
      sheetCam: {
        sheetId: sheetURL_c.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_c,
      },
      checkExistedCampaign,
      includesKeyword,
      includesAds,
      tabsNum
    };
    axios
      .post(`${API_HOST}/api/up-cam-profiles`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Up CAM Profiles ~ error:", e);
        messageApi.error(e.response.data);
      });
  };
  const listPages = async() => {
    axios
    .post(`${API_HOST}/api/account/up-campaign-pages`, {sheetId: sheetURL_c.split('/d/')[1].split('/edit')[0]})
    .then((res) => {
      if(res.data) {
        setPages(res.data);
      }
    })
    .catch((e) => {
      console.log("🚀 ~ UP campaign(pages) ~ e:", e);
    });
  }
  useEffect(() => {
    let sheetNameP = localStorage.getItem('cam-profiles-sheetName')
    if(sheetNameP) {
      setSheetName_p(sheetNameP)
    }
    let sheetURLP = localStorage.getItem('cam-profiles-sheetURL')
    if(sheetURLP) {
      setSheetURL_p(sheetURLP)
    }

    let tabsNum = localStorage.getItem('cam-profiles-tabs')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }

    let sheetNameC = localStorage.getItem('cam-sheetName')
    if(sheetNameC) {
      setSheetName_c(sheetNameC)
    }
    let sheetURLC = localStorage.getItem('cam-sheetURL')
    if(sheetURLC) {
      setSheetURL_c(sheetURLC)
    }
    let checkExistedCampaign = localStorage.getItem('check-existed-campaign')
    if(checkExistedCampaign) {
      setCheckExistedCampaign(checkExistedCampaign == 'true');
    }
    let includesKeyword = localStorage.getItem('includes-keyword')
    if(includesKeyword) {
      setIncludesKeyword(includesKeyword == 'true');
    }
    let includesAds = localStorage.getItem('includes-ads')
    if(includesAds) {
      setIncludesAds(includesAds == 'true');
    }
  }, [])

    const onOpenChange = (open) => {
    if (open) {
      listPages();
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Up CAM Profiles"
        description={
          <div style={{ width: '500px' }}>
            <b>Profiles GG sheet: </b>
            <Row>
              <Col span={4}>
                <label>SL Chrome: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={tabsNum}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng Chrome..."
                  onChange={(e) => {
                    setTabsNum(e.target.value);
                    localStorage.setItem('cam-tabs', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={18}>
               <Input
                  value={sheetURL_p}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_p(e.target.value);
                    localStorage.setItem('cam-profiles-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={18}>
                 <Input
                    value={sheetName_p}
                    style={{ width: 200 }}
                    placeholder="Trang Up CAM..."
                    onChange={(e) => {
                      setSheetName_p(e.target.value);
                      localStorage.setItem('cam-profiles-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>
            <b>CAM GG sheet: </b>
            <br />
            <Checkbox checked={checkExistedCampaign} onChange={e => {
              setCheckExistedCampaign(e.target.checked);
              localStorage.setItem('check-existed-campaign', `${e.target.checked}`);
            }}>
              Check Đã Có CAM - Bỏ Qua
            </Checkbox>
            <br />
            <Checkbox checked={includesKeyword} onChange={e => {
              setIncludesKeyword(e.target.checked);
              localStorage.setItem('includes-keyword', `${e.target.checked}`);
            }}>
              + Keyword
            </Checkbox>
            <br />
            <Checkbox checked={includesAds} onChange={e => {
              setIncludesAds(e.target.checked);
              localStorage.setItem('includes-ads', `${e.target.checked}`);
            }}>
              + Ads
            </Checkbox>
            <br />
            <Row>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={18}>
               <Input
                  value={sheetURL_c}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_c(e.target.value);
                    localStorage.setItem('cam-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={18}>
                  <Select
                    mode={"multiple"}
                    maxCount={1}
                    style={{width: 200}}
                    value={sheetName_c}
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    placeholder="Chọn Trang ... "
                    onChange={(v) => {
                      setSheetName_c(v);
                      localStorage.setItem('cam-sheetName', v);
                    }}
                    options={pages?.map((page) => ({
                      label: page.title,
                      value: page.title,
                    }))}
                />
                 {/* <Input
                    value={sheetName_c}
                    style={{ width: 200 }}
                    placeholder="Trang Up CAM..."
                    onChange={(e) => {
                      setSheetName_c(e.target.value);
                      localStorage.setItem('cam-sheetName', e.target.value);
                    }}
                  /> */}
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => upCam()}
      >
        <Button ><CloudUploadOutlined />Up CAM</Button>
      </Popconfirm>
    </>
  );
}